<!-- Isolate this component to avoid rerendering PlanningElementView on every selection change
==> Huge performance gap -->

<template>
  <article :class="{ selected: ! disableStyling && elIsSelected }">
    <slot></slot>
  </article>
</template>

<script>
  import useSelectionStore from '@/stores/selection';

  export default {
    props: {
      el: { type: Object, required: true },
      disableStyling: { type: Boolean, default: false },
    },
    data() {
      return {
        selectionStore: useSelectionStore(),
      };
    },
    computed: {
      elIsSelected() {
        return this.selectionStore.selection.has(this.el.id);
      },
    },
  };
</script>
